import bottomBar from './bottomBar.vue'

const bottomBars = {
    install(Vue){
        Vue.component('bottomBar',bottomBar)
    }
}
export default bottomBars